import { render, staticRenderFns } from "./managedInstructionLocalEditDialog.vue?vue&type=template&id=6eb52331"
import script from "./managedInstructionLocalEditDialog.vue?vue&type=script&lang=js"
export * from "./managedInstructionLocalEditDialog.vue?vue&type=script&lang=js"
import style0 from "./managedInstructionLocalEditDialog.vue?vue&type=style&index=0&id=6eb52331&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports